module.exports = __webpack_public_path__ + "img/after.7d6b4db5.png";